(function (app) {

    app.provider("amplitudeApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        var service = {};

                        service.logEvent = (eventObj) => {
                            return crmApiGateway.post('/amplitude', eventObj);
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line